import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const CashPaymentList = () => {
    const [payments, setPayments] = useState([]);
    const [filteredPayments, setFilteredPayments] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}cashpayment`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setPayments(data.data);
                    setFilteredPayments(data.data);
                } else {
                    alert('Failed to fetch cash payment entries');
                }
            })
            .catch(error => console.error('Error fetching payments:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = payments.filter(payment =>
            payment.description?.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredPayments(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditCashPayment/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddCashReceived');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this payment?")) {
            fetch(`${BASE_URL}cashpayment/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setPayments(payments.filter(payment => payment.id !== id));
                        setFilteredPayments(filteredPayments.filter(payment => payment.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting payment:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Cash Payment List</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="searchTerm" className="form-label">Search by Description</label>
                                        <input
                                            type="text"
                                            id="searchTerm"
                                            className="form-control"
                                            placeholder="Search description"
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={handleAdd}>Add Payment</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>STAFF ID</th>
                                                <th>AMOUNT</th>
                                                <th>DESCRIPTION</th>
                                                <th>CREATED AT</th>
                                                <th className="text-end">ACTION</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredPayments.map(payment => (
                                                <tr key={payment.id}>
                                                    <td>{payment.id}</td>
                                                    <td>{payment.staff_id || 'N/A'}</td>
                                                    <td>{payment.amount}</td>
                                                    <td>{payment.description || 'N/A'}</td>
                                                    <td>{new Date(payment.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button className="btn btn-success" onClick={() => handleEdit(payment.id)}>Edit</button>
                                                        <button className="btn btn-danger ms-2" onClick={() => handleDelete(payment.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CashPaymentList;
